export enum BeneficiariesSuccessCodes {
  ADD_BENEFICIARY = 'add_beneficiary',
  UPDATE_BENEFICIARY = 'update_beneficiary',
  REMOVE_BENEFICIARY = 'remove_beneficiary',
  ADD_FAVORITE_BENEFICIARY = 'add_favorite_beneficiary',
  REMOVE_FAVORITE_BENEFICIARY = 'remove_favorite_beneficiary',
}
